/**
 * Toggles a class between two states
 * 
 * @export
 * @class Toggler
 */
export class Toggler {
    public isActive = false;
    private target: HTMLElement;
    private className: string;


    /**
     * Creates an instance of Toggler.
     * 
     * @param {HTMLElement} target 
     * @param {string} className 
     * @param {boolean} [isActive] 
     * @memberof Toggler
     */
    constructor(target: HTMLElement, className: string, isActive?: boolean) {
        this.target    = target;
        this.className = className;
        this.isActive  = typeof isActive === 'undefined' ? this.isActive : isActive;
    }


    /**
     * Deactivates if the element already has the class, activates if it doesn't
     * 
     * @param {() => void} [callback]
     * @memberof Toggler
     */
    toggle(callback?: () => void): void {
        if(this.target.classList.contains(this.className)) {
            this.remove(callback)
        } else {
            this.add(callback);
        }
    }


    /**
     * Sets our isActive property to true and adds our class. Optionally 
     * executes the callback
     * 
     * @param {() => void} [callback]
     * @memberof Toggler
     */
    add(callback?: () => void): void {
        this.isActive = true;
        this.target.classList.add(this.className);
        if(typeof callback === 'function') callback();
    }


    /**
     * Sets our isActive property to false and removes our class. Optionally 
     * executes the callback
     * 
     * @param {() => void} [callback]
     * @memberof Toggler
     */
    remove(callback?: () => void): void {
        this.isActive = false;
        this.target.classList.remove(this.className);
        if(typeof callback === 'function') callback();
    }
}